import dayjs from 'dayjs';
import { normalizeCheckboxGroupValue } from '@/utils';

/** Consent form only: Checkbox.Group needs a real array (API may return an object/string). */
export const ensureArray = (val: unknown): any[] => normalizeCheckboxGroupValue(val);

/** API may return a non-string date; avoid .includes / .trim on the wrong type (prod: includes is not a function). */
export const asDateInputString = (val: unknown): string => {
  if (val == null) return '';
  if (typeof val === 'string') return val;
  return String(val);
};

export const calculateOneMonthInclusiveEnd = (baseDate: dayjs.Dayjs): string => {
  const targetMonth = baseDate.add(1, 'month');
  const baseDay = baseDate.date();

  if (baseDay > targetMonth.daysInMonth()) {
    return targetMonth.endOf('month').format('YYYY-MM-DD');
  }

  return targetMonth.date(baseDay).subtract(1, 'day').format('YYYY-MM-DD');
};

export const arraysEqual = (a: unknown[], b: unknown[]) =>
  a.length === b.length && a.every(value => b.includes(value));
